<template>
  <div v-if="summary">
    <div v-if="metrics.length > 0">
      <span v-bind:class="{ danger: metrics[0].cpuPercent > 70 }">
        <i class="el-icon-odometer" /> {{ metrics[0].cpuPercent }}% CPU
      </span>
      <span v-bind:class="{ danger: metrics[0].memPercent > 90 }">
        <i class="el-icon-cpu" /> {{ metrics[0].memPercent }}% Memory
      </span>
      <span v-bind:class="{ danger: metrics[0].diskPercent > 90 }">
        <i class="el-icon-coin" /> {{ metrics[0].diskPercent }}% Disk
      </span>
    </div>

    <el-button
      type="text"
      size="mini"
      @click="$router.push('/instances/' + instance.id + '/metrics')"
    >
      Show Graphs
    </el-button>
  </div>

  <div v-else>
    <el-page-header content="Graphs" @back="$emit('back')" />

    <h4>CPU Usage</h4>
    <TrendChart
      v-if="cpu.length > 0"
      class="trend-metrics"
      :datasets="[{ data: cpu, smooth: true, fill: true }]"
      :labels="{ yLabels: 5 }"
      :min="0"
      :max="100"
    />

    <h4>Memory Usage</h4>
    <TrendChart
      v-if="memory.length > 0"
      class="trend-metrics"
      :datasets="[{ data: memory, smooth: true, fill: true }]"
      :labels="{ yLabels: 5 }"
      :min="0"
      :max="100"
    />

    <h4>Disk Usage</h4>
    <TrendChart
      v-if="disk.length > 0"
      class="trend-metrics"
      :datasets="[{ data: disk, smooth: true, fill: true }]"
      :labels="{ yLabels: 5 }"
      :min="0"
      :max="100"
    />
  </div>
</template>

<script>
import TrendChart from 'vue-trend-chart'

export default {
  props: {
    instance: Object,
    summary: {
      type: Boolean,
      default: false
    },
    timeout: {
      type: Boolean,
      default: false
    }
  },
  components: {
    TrendChart
  },
  data () {
    return {
      loop: null,
      metrics: []
    }
  },
  computed: {
    cpu () {
      return this.metrics.map((value) => value.cpuPercent)
    },
    memory () {
      return this.metrics.map((value) => value.memPercent)
    },
    disk () {
      return this.metrics.map((value) => value.diskPercent)
    },
    config () {
      let range

      if (this.summary === false) {
        range = '6h'
      }

      return {
        range,
        id: this.instance.id
      }
    }
  },
  created () {
    this.load()
  },
  mounted () {
    this.loop = window.setInterval(() => {
      this.$store.dispatch('getInstanceMetrics', this.config)
        .then((res) => {
          this.metrics = res.data
        }).catch(() => {})
    }, 60000)
  },
  beforeDestroy () {
    if (this.loop) {
      window.clearInterval(this.loop)
      this.loop = null
    }
  },
  methods: {
    load () {
      this.$store.dispatch('getInstanceMetrics', this.config)
        .then((res) => {
          this.metrics = res.data
        }).catch(() => {})
    }
  },
  watch: {
    instance (value) {
      if (value) {
        this.load()
      }
    }
  }
}
</script>

<style lang="scss">
  .trend-metrics {
    .vtc {
      height: 250px;
      font-size: 10px;
      @media (min-width: 699px) {
        height: 350px;
      }
    }

    .curve {
      .stroke {
        stroke: #b6ede0;
        stroke-width: 2;
      }

      .fill {
        fill: #d1f4eb;
        fill-opacity: 0.5;
      }

      &.in, &.out {
        .fill {
          fill: transparent;
        }
      }

      &.out {
        .stroke {
          stroke: #faca7c;
        }
      }
    }

    .y-labels,
    .x-labels {
      .label {
        font-size: 11px;
      }
    }
  }
</style>

<style lang="scss" scoped>
  @import "../../theme";

  .danger {
    color: $--color-danger;
  }

  i {
    margin-left: 15px;
  }

  .el-button {
    padding: 0;
  }
</style>
